export const NOTETAKER_EMAIL = 'notes@hirehire.ai'
